<template>
  <div class="checkout-payment-credit-card mt-4" v-if="recurlyElements">
    <div class="checkout-payment-credit-card-grid">
      <RecurlyCreditCardNumber :styles="baseStyles" ref="number" />
      <div class="checkout-payment-credit-card-meta">
        <RecurlyCreditCardExpiration :styles="baseStyles" ref="expiration" />
        <RecurlyCreditCardCvv :styles="baseStyles" ref="cvv" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import RecurlyCreditCardNumber from './RecurlyCreditCardNumber.vue'
import RecurlyCreditCardExpiration from './RecurlyCreditCardExpiration.vue'
import RecurlyCreditCardCvv from './RecurlyCreditCardCvv.vue'
import { useRecurlyStore } from '@/store/RecurlyStore'

const recurlyStore = useRecurlyStore()
const { instantiateElements } = recurlyStore
const { recurlyElements } = storeToRefs(recurlyStore)

const baseStyles = computed(() => ({
  fontColor: '#0d0e0f',
  placeholderColor: 'rgba(13, 14, 15, 0.6)',
  fontFeatureSettings: 'normal',
  fontKerning: 'auto',
  fontSize: '14px',
  fontSmoothing: 'antialiased',
  fontStyle: 'normal',
  fontVariant: 'normal',
  fontWeight: '600',
  letterSpacing: '0.8px',
  lineHeight: 'normal',
  textShadow: 'none',
  textTransform: 'none',
  fontFamily: 'Inter',
  invalid: {
    fontColor: '#c34138'
  }
}))

onMounted(() => instantiateElements())

const number = ref<InstanceType<typeof RecurlyCreditCardNumber>>()
const expiration = ref<InstanceType<typeof RecurlyCreditCardExpiration>>()
const cvv = ref<InstanceType<typeof RecurlyCreditCardCvv>>()

const isValid = computed(() => number.value?.isValid && expiration.value?.isValid && cvv.value?.isValid)

defineExpose({ isValid })
</script>
<style lang="scss">
.checkout-payment-credit-card {
  &-grid {
    display: grid;
    grid-template-columns: 1fr;
  }

  &-meta {
    display: grid;
    grid-template-columns: 1fr;

    @media screen and (min-width: $grid-breakpoint-sm) {
      grid-gap: $grid-gutter-width;
      grid-template-columns: 1fr 1fr;
    }
  }

  .input-field {
    iframe {
      display: block;
    }
  }
}
</style>
